export const HEIGHT_SCALE_MINIMIZER = 0.9
export const INITIAL_KONVA_ZOOM_SCALE = 0.5
export const KONVA_ZOOM_SCALE = 1.2
